import { EFontFamily } from "motw_core/Enums/EFontFamily";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import {
    ReadState,
    ReadStateOrDefault,
} from "source/app/services/UI/State/ReadState";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";

export function GetWorkflowNodeFontStyle(node: IWorkflowNode) {
    const useAnopenscrollFont = ReadStateOrDefault(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        false
    );

    if (useAnopenscrollFont) {
        return GetFontStyle("inherit");
    }

    const fontFamily = GetFontFamily(node);

    if (fontFamily) {
        const fontStyle = GetFontStyle(EFontFamily[fontFamily]);
        return fontStyle;
    }

    const defaultFontFamilyIndex = 0;
    const defaultFontFamily = EFontFamily[defaultFontFamilyIndex];

    const breadCrumbs = ReadState<IWorkflowNode[]>(
        ESharedFunction.BreadCrumbs_state
    );

    if (!breadCrumbs || breadCrumbs.length === 0) {
        const fontStyle = GetFontStyle(defaultFontFamily);
        return fontStyle;
    }

    const parentsWithCustomFonts = breadCrumbs.filter(
        (node) =>
            GetFontFamily(node) !== undefined &&
            GetFontFamily(node) !== null &&
            GetFontFamily(node) !== defaultFontFamilyIndex
    );

    if (parentsWithCustomFonts.length === 0) {
        const fontStyle = GetFontStyle(defaultFontFamily);
        return fontStyle;
    }

    const fontFamilyIndex = GetFontFamily(parentsWithCustomFonts[0])!;
    const fontFamilyName = EFontFamily[fontFamilyIndex];
    const fontStyle = GetFontStyle(fontFamilyName);
    return fontStyle;
}

const GetFontStyle = (fontFamily: string) => {
    return {
        fontFamily,
    };
};

const GetFontFamily = (node: IWorkflowNode) => node.options?.fontFamily;
